import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";
import { safeReturnTarget } from "./returnTarget";
import { BrandImage } from "../../components/brandImage";
import { FormChangePassword } from "./formChangePassword";
import { FormLogin } from "./formLogin";
import { FormRegister } from "./formRegister";
import { FormRecover } from "./formRecover";
import "./style.css";
import "./responsive.css";
import "./auth-design.css";

const copy = {
  login: ["Bienvenido de nuevo", "Accede para continuar tu pedido y consultar tus compras."],
  register: ["Crear cuenta", "Solo necesitamos tus datos para finalizar la compra."],
  forgotPassword: ["Recupera tu contraseña", "Introduce tu email para recibir un enlace de recuperación."],
  changePassword: ["Elige una nueva contraseña", "Introduce tu contraseña y confírmala para continuar."],
  passwordChanged: ["Contraseña actualizada", "Ya puedes iniciar sesión con tu nueva contraseña."],
};

export default function Login() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const checkout = safeReturnTarget(params.get("returnTo")) === "/checkout";
  const back = safeReturnTarget(params.get("back"));
  const [verifying, setVerifying] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [mode, setMode] = useState("login");
  const info = useSelector(state => state.aplicationConfig.corporationData.info);
  const navigate = useNavigate();
  const [title, description] = verifying && mode === "login" ? ["Verifica tu cuenta", "Introduce tu código de verificación para continuar."] : checkout && mode === "login" ? ["Continúa con tu pedido", "Inicia sesión o crea tu cuenta para finalizar la compra."] : copy[mode] || copy.login;
  return <main className={`loginArea eats-auth ${checkout ? "eats-checkout-auth" : ""}`}>
    <div className="eats-auth-shell">
      <button type="button" className="eats-auth-back" onClick={() => navigate(checkout ? back : "/", { state: checkout && back === "/" ? { openCartOnReturn: true } : null })}><LuArrowLeft aria-hidden="true" />{checkout ? "Volver al pedido" : "Volver a la carta"}</button>
      <section className="loginContainer eats-auth-card" aria-labelledby="auth-title">
        <div className="eats-auth-intro">
          {!checkout && <BrandImage src={info?.logo} className="eats-auth-logo" />}
          {!checkout && <p className="eats-auth-store">Tu cuenta en {info?.corporation?.name || "nuestra tienda"}</p>}
          <h1 id="auth-title">{title}</h1>
          <p className="eats-auth-description">{description}</p>
        </div>
        {registered && mode === "login" && <p role="status">Solicitud recibida. Puedes iniciar sesión o recuperar tu contraseña. Si no puedes acceder, revisa los datos de registro, incluido el teléfono.</p>}
        {mode === "login" && <FormLogin onVerificationRequired={() => { setRegistered(false); setVerifying(true); }} checkoutAccess={checkout} callback={() => setMode("forgotPassword")} />}
        {mode === "register" && <FormRegister onRegistered={() => { setRegistered(true); setMode("login"); }} />}
        {mode === "forgotPassword" && <FormRecover />}
        {mode === "changePassword" && <FormChangePassword callback={success => { if (success) setMode("passwordChanged"); }} />}
        <div className="registerInfo eats-auth-footer">
          {mode === "login" ? <><span>¿Aún no tienes cuenta?</span><button type="button" onClick={() => { setVerifying(false); setMode("register"); }}>Crear cuenta</button></> : mode === "register" ? <><span>¿Ya tienes cuenta?</span><button type="button" onClick={() => setMode("login")}>Iniciar sesión</button></> : <button type="button" onClick={() => setMode("login")}>Volver al inicio de sesión</button>}
        </div>
      </section>
    </div>
  </main>;
}
